<template>
  <div class="findFormContaniner">
    <div class="form">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" size="mini">
        <el-form-item :label="'手机号码'">{{userInfo.mobile}}</el-form-item>
        <el-form-item label="验证码" prop="authCode" class="elInputCustomer">
          <el-input v-model="ruleForm.authCode"></el-input>
          <span class="getAuthCode cursorPointer" @click="getAuthCode" v-if="!countdowning">获取验证码</span>
          <span class="getAuthCode" v-if="countdowning">{{countdownValue+'后重新获取'}}</span>
        </el-form-item>
        <el-form-item label="新密码" prop="pwd">
          <el-input type="password" v-model="ruleForm.pwd"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPwd">
          <el-input type="password" v-model="ruleForm.confirmPwd"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" :disabled="isSubmitIng" @click="submitForm('ruleForm')">提交</el-button>
    </div>
  </div>
</template>
<script>
import Dialog from "@common/Dialog.vue";
import Reg from "@lib/reg.js";
import BaseApi from "@lib/baseApi.js";
import md5Util from "@lib/encryption.js";
import {mapMutations} from "vuex";
export default {
  data() {
    var validatePassConFirm = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.pwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      show: true,
      countdownValue: 60,
      countdowning: false,
      ruleForm: {
        mobile: "",
        authCode: "",
        pwd: "",
        confirmPwd: "",
        mail: ""
      },
      isSubmitIng: false,
      userInfo: null,
      rules: {
        authCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: Reg.AUTHCODE,
            message: "验证码为6位数字",
            trigger: "blur"
          }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: Reg.PWD,
            message: "密码为6-18位密码",
            trigger: "blur"
          }
        ],
        confirmPwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePassConFirm, trigger: "blur" }
        ]
      }
    };
  },
  components: {
    Dialog
  },
  created() {
    BaseApi.createRpcToken("/user/v2/getUserInfo").then(
      data => {
        this.userInfo = data.datas;
      },
      err => {}
    );
  },
  mounted() {},
  methods: {
    ...mapMutations(['setUpdateUserState']),
    getAuthCode() {
      BaseApi.createRpcToken(
        "/common/getRetrievePasswordCode",
        {
          account: this.userInfo.mobile
        },
        "post"
      ).then(
        data => {
          this.doCountdown();
        },
        () => {}
      );
    },
    doCountdown: function() {
      if (this.countdownValue == 1) {
        this.countdowning = false;
        this.countdownValue = 60;
        return;
      }
      setTimeout(this.doCountdown, 1000);
      this.countdowning = true;
      this.countdownValue--;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let query = {
            account: this.userInfo.mobile,
            password: md5Util.md5(this.ruleForm.pwd),
            verifyCode: this.ruleForm.authCode
          };
          BaseApi.createRpcToken("/user/resetPwd", query, "post").then(
            data => {
              console.log(data);
              this.setUpdateUserState("setPwdByMobile")
              this.$message.success("密码设置成功");
              setTimeout(() => {
                this.$router.push({
                  path: "/personal/users/home"
                });
                this.isSubmitIng = false;
              }, 2000);
            },
            () => {}
          );
        } else {
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.findFormContaniner {
  height: 290px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  .form {
    width: 330px;
    margin-top: 30px;
    margin-bottom: 10px;
    .elInputCustomer {
      .el-form-item__content {
        .el-input {
          width: 138px;
        }
        .getAuthCode {
          margin-left: 5px;
          font-size: 12px;
          color: #e88078;
          cursor: pointer;
          display: inline-block;
          line-height: 27px;
          text-align: center;
          width: 85px;
          border: 1px solid #e88078;
          vertical-align: top;
          border-radius: 3px;
        }
      }
    }
  }
}
</style>
